<div class="flex justify-center mb-10 bg-gray-50">
  <div class="w-full max-w-[1500px] py-8 px-4">
    <!-- Header -->
    <div class="mb-12 flex justify-between items-center">
      <div>
        <div class="inline-block">
          <h2 class="text-4xl md:text-5xl font-extrabold text-gray-900 tracking-tight">
            Popular Book
          </h2>
          <div class="mt-3 h-1.5 bg-gradient-to-r from-blue-600 via-yellow-400 to-yellow-500 rounded-full w-full shadow-md"></div>
        </div>
        <p class="mt-4 text-gray-600 text-lg">Click on any Magazine to preview or download</p>
      </div>
      <div class="w-1/3">
        <mat-form-field class="w-full" appearance="outline">
          <mat-label>Search</mat-label>
          <input matInput [formControl]="searchControl" placeholder="Search by keyword">
          <mat-icon matSuffix>search</mat-icon>
        </mat-form-field>
      </div>
    </div>

    <!-- Loading State -->
    @if (loading) {
      <div class="flex items-center justify-center py-20">
        <div class="flex flex-col items-center gap-6">
          <mat-spinner diameter="60"></mat-spinner>
          <p class="text-gray-700 text-xl font-semibold">Loading Book...</p>
        </div>
      </div>
    }

    <!-- Empty State -->
    @else if (magazines.length === 0) {
      <div class="flex items-center justify-center py-20">
        <div class="text-center">
          <mat-icon class="text-gray-400 mb-4" style="font-size: 96px; width: 96px; height: 96px;">library_books</mat-icon>
          <h3 class="text-3xl font-bold text-gray-800 mb-3">No Book Available</h3>
          <p class="text-gray-500 text-lg">Check back soon for new publications</p>
        </div>
      </div>
    }

    <!-- Magazine Grid with Carousel -->
    @else {
      <div class="relative">
        <!-- Navigation Arrows (Only show if more than visibleCount magazines) -->
        @if (showNavigationArrows) {
          <!-- Previous Arrow -->
          <button 
            (click)="previousSlide()"
            [disabled]="!canNavigatePrev"
            [class.opacity-50]="!canNavigatePrev"
            [class.cursor-not-allowed]="!canNavigatePrev"
            class="absolute left-0 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-gray-100 text-gray-800 p-4 rounded-full shadow-lg transition-all duration-300 disabled:hover:bg-white group">
            <mat-icon class="text-3xl group-hover:scale-110 transition-transform">chevron_left</mat-icon>
          </button>

          <!-- Next Arrow -->
          <button 
            (click)="nextSlide()"
            [disabled]="!canNavigateNext"
            [class.opacity-50]="!canNavigateNext"
            [class.cursor-not-allowed]="!canNavigateNext"
            class="absolute right-0 top-1/2 -translate-y-1/2 z-10 bg-white hover:bg-gray-100 text-gray-800 p-4 rounded-full shadow-lg transition-all duration-300 disabled:hover:bg-white group">
            <mat-icon class="text-3xl group-hover:scale-110 transition-transform">chevron_right</mat-icon>
          </button>
        }

        <!-- Carousel Container -->
        <div class="overflow-hidden px-12">
          <div 
            class="flex transition-transform duration-500 ease-in-out"
            [style.transform]="'translateX(-' + (currentIndex * slideWidth) + '%)'">
            @for (mag of magazines; track mag.id; let i = $index) {
              <div 
                class="flex-shrink-0 px-4"
                [style.width]="slideWidth + '%'">
                <div class="bg-white rounded-2xl shadow-lg p-6 hover:shadow-2xl transition-all duration-300 cursor-pointer"
                     (click)="openMagazineReader(mag)">
                  <!-- Thumbnail -->
                  <div class="h-80 bg-gray-100 rounded-lg flex items-center justify-center mb-4">
                    @if (mag.isLoadingThumb) {
                      <mat-spinner diameter="40"></mat-spinner>
                    }
                    @else if (mag.thumbnailUrl) {
                      <img [src]="mag.thumbnailUrl" 
                           [alt]="mag.title"
                           class="h-full w-auto object-contain rounded-lg"
                           (error)="onImageError($event)">
                    }
                    @else {
                      <mat-icon class="text-gray-400 text-6xl">image</mat-icon>
                    }
                  </div>

                  <!-- Title and Actions -->
                  <h3 class="text-xl font-bold text-gray-900 mb-3 line-clamp-2">
                    {{ mag.title }}
                  </h3>
                  
                  <div class="flex gap-2">
                    <button (click)="openMagazineReader(mag, $event)"
                            class="flex-1 bg-blue-600 text-white px-4 py-2 rounded-lg hover:bg-blue-700 transition-colors flex items-center justify-center gap-2">
                      <mat-icon>open_in_new</mat-icon>
                      <span>Open</span>
                    </button>
                    <button (click)="downloadPdf(mag, $event)"
                            class="flex-1 bg-green-600 text-white px-4 py-2 rounded-lg hover:bg-green-700 transition-colors flex items-center justify-center gap-2">
                      <mat-icon>download</mat-icon>
                      <span>Download</span>
                    </button>
                  </div>
                </div>
              </div>
            }
          </div>
        </div>

        <!-- Pagination Dots (Optional) -->
        @if (showNavigationArrows) {
          <div class="flex justify-center gap-2 mt-8">
            @for (item of magazines; track item.id; let i = $index) {
              @if (i % visibleCount === 0) {
                <button 
                  (click)="currentIndex = i"
                  [class.bg-blue-600]="currentIndex === i"
                  [class.bg-gray-300]="currentIndex !== i"
                  class="w-3 h-3 rounded-full transition-all duration-300 hover:scale-125">
                </button>
              }
            }
          </div>
        }
      </div>
    }
  </div>
</div>